import React, {useContext} from 'react'

//Node Modules
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

//Contexts
import { RequestorContext } from 'context/content-context'

//Components
import { PreviousIcon, NextIcon } from 'components/SASIcon'

//Styles
import styles from './ContentNavigation.module.scss'

interface Props {
  prev?: string
  next?: string
}

const ContentNavigation = ({prev, next}:Props) => {
  const requestorId = useContext(RequestorContext)
  const { t } = useTranslation()

  const prevDisabled = prev === undefined
  const nextDisabled = next === undefined

  const keypressHandler = (e: React.KeyboardEvent) => {
    if (e.keyCode === 32) {
      let target = e.target as HTMLElement
      target.click()      
    }
  }

  return (
    <>
      <div className={`${styles.contentnavigation} contentnavigation`}>
        <div className={`${styles.prevBtn} prevBtn`} role="application">
          {
            
            prevDisabled ?
              <span className={`${styles.navbutton} ${styles.disabled}`}>
                <PreviousIcon />
              </span> :
              <Link 
                to={`${prev}${requestorId ? '?requestorId='+requestorId : ''}` as string} 
                className={`${styles.navbutton} ${ prevDisabled&& styles.disabled }`} 
                title={t('helpcenter-gui-icu.content.navigation.previous.label')}
                onKeyDown={keypressHandler}
              >
                <PreviousIcon />
              </Link>
          }
        </div>
        <div className={`${styles.nextBtn} nextBtn`} role="application">
          {
            nextDisabled ?
              <span className={`${styles.navbutton} ${styles.disabled}`}>
                <NextIcon />
              </span> :
              <Link 
                to={`${next}${requestorId ? '?requestorId='+requestorId : ''}` as string} 
                className={`${styles.navbutton} ${ nextDisabled&& styles.disabled }`} 
                title={t('helpcenter-gui-icu.content.navigation.next.label')}
                onKeyDown={keypressHandler}
              >
                <NextIcon />
              </Link>
          }
        </div>
      </div>
    </>
  )
}

export default ContentNavigation